import { employeeLegalEntity } from 'modules/core/lib/employeeLegalEntity'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import { employeeJobLevel } from 'modules/job_catalog/store/collections/levels'
import { jobLevelRole } from 'modules/job_catalog/store/collections/roles'

interface ReturnType {
  employees: Employee[]
}

const useEmployeesWithWrongJobLevel = (
  employees: Employee[],
  contractVersions: ContractVersions
): ReturnType => {
  const employeesWithWrongJobLevel = employees.reduce<Employee[]>((acc, employee) => {
    const level = employeeJobLevel(contractVersions, employee)
    const role = level ? jobLevelRole(level) : null
    const legalEntity = employeeLegalEntity(employee)

    if (level && level?.isArchived) {
      acc.push(employee)
      return acc
    }

    if (level && (!role?.isRoleInLegalEntity(legalEntity) || role?.isArchived)) {
      acc.push(employee)
      return acc
    }
    return acc
  }, [])

  return { employees: employeesWithWrongJobLevel }
}
export default useEmployeesWithWrongJobLevel
